import React from 'react';

import { formatPhone } from '../../utils/helpers';
import { Typography, TypographyProps } from '../Typography/Typography';

export interface MaskedPhoneDisplayProps extends TypographyProps {
  text: string;
  preText?: string;
  postText?: string;
}

export const MaskedPhoneDisplay = (props: MaskedPhoneDisplayProps) => {
  const { text, preText, postText, ...propsRest } = props;

  const displayText = `${preText || ''}${formatPhone(text)}${postText || ''}`;

  return <Typography text={displayText} {...propsRest} />;
};
